import {useEffect} from 'react';
import {Callback} from 'app/types/common';

export function useComponentWillUnmount(fn: Callback) {
  useEffect(() => fn, []);
}
